/** Homepage game tiles — ids match App.tsx Screen navigation */
export type HomeGameScreen = 'animal-abcs' | 'tree-level' | 'creature-superpowers' | 'peke-level';

export interface HomeGameCard {
  id: HomeGameScreen;
  title: { en: string; es: string };
  description: { en: string; es: string };
  /** Flat fill — harmonized meadow palette (same as homepage) */
  color: string;
  emoji: string;
}

export const HOME_GAME_CARDS: HomeGameCard[] = [
  {
    id: 'animal-abcs',
    title: { en: 'Animal ABCs, 123s', es: 'ABC de Animales, 123' },
    description: {
      en: 'Letters & numbers with animals—great for first steps.',
      es: 'Letras y números con animales—ideal para primeros pasos.',
    },
    color: '#5EBD8B',
    emoji: '📚',
  },
  {
    id: 'tree-level',
    title: { en: 'Pepe Knows', es: 'Pepe Sabe' },
    description: {
      en: 'Stories and learning with Pepe the wise tree.',
      es: 'Historias y aprendizaje con Pepe el árbol sabio.',
    },
    color: '#48A589',
    emoji: '🌳',
  },
  {
    id: 'creature-superpowers',
    title: { en: 'Superpowers', es: 'Superpoderes' },
    description: {
      en: 'Choose a creature, powers, and draw—pure imagination.',
      es: 'Elige criatura, poderes y dibuja—pura imaginación.',
    },
    color: '#358A73',
    emoji: '✨',
  },
  {
    id: 'peke-level',
    title: { en: "Peke's Adventures", es: 'Las Aventuras de Peke' },
    description: {
      en: 'Adventures with Peke the Boston Terrier.',
      es: 'Aventuras con Peke el Boston Terrier.',
    },
    color: '#3BB257',
    emoji: '🐕',
  },
];
